// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__121Su","head":"ProcedureTableInfo_head__Wxos1"};